import { CircularProgress, Flex } from '@chakra-ui/react'
import { ActionButton, BoxHeader, UploadProgressOverlay } from '@hb/shared-frontend'
import { SvgIcon } from '@hb/shared-frontend/icons'
import saveIcon from '@hb/shared-frontend/icons/save_old_green.svg'
import { useCallback, useState } from 'react'
import { CoverageOptionSelect } from './CoverageOption'
import { PrimaryCoverageSelect, SecondaryCoverageSelect } from './CoverageSelect'
import { InsuranceInfoStageProvider, useInsuranceInfoStage } from './context'

const SaveChangesButton = () => {
  const { onSaveChanges, hasChanges } = useInsuranceInfoStage()
  const [isLoading, setIsLoading] = useState(false)
  const handleClick = useCallback(async () => {
    setIsLoading(true)
    await onSaveChanges()
    setIsLoading(false)
  }, [onSaveChanges])
  return (
    <ActionButton
      opacity={hasChanges ? 1 : 0}
      transition="opacity 300ms"
      onClick={handleClick}
      isLoading={isLoading}
      gap={1.5}
      size="xs"
      variant="outline">
      <SvgIcon src={saveIcon} />
      Save Changes
    </ActionButton>
  )
}
const InsuranceInfoStageBody = () => {
  const { isSaving, uploads } = useInsuranceInfoStage()
  return (
    <Flex position="relative" bg="gray.100" py={3} px={4} flexFlow="column" w="100%">
      <Flex pr={10} w="100%" gap={2}>
        <BoxHeader fontSize="xl" color="gray.700">
          Insurance Information
        </BoxHeader>
        <CircularProgress
          position="relative"
          top="3px"
          opacity={isSaving ? 1 : 0}
          transition="opacity 300ms"
          isIndeterminate={isSaving}
          size="20px"
          color="gray.500"
        />
        <Flex ml="auto" align="center">
          <SaveChangesButton />
        </Flex>
      </Flex>
      <CoverageOptionSelect />
      <PrimaryCoverageSelect />
      <SecondaryCoverageSelect />
      <UploadProgressOverlay uploads={uploads} />
    </Flex>
  )
}

export const InsuranceInfoStage = () => (
  <InsuranceInfoStageProvider>
    <InsuranceInfoStageBody />
  </InsuranceInfoStageProvider>
)
